import React, { useState } from 'react';

import AdminCommentCard from '../AdminCommentCard/AdminCommentCard';
import AdminCardOrderField from '../admin-card-fields/AdminCardOrderField/AdminCardOrderField';
import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import { MdExpandLess, MdExpandMore } from 'react-icons/md';

import './AdminBlogPostCard.css';

const AdminBlogPostCard = ({
  blogPost,
  onBlogPostEditClickHandler,
  onBlogPostDeleteClickHandler,
  onCommentAddClickHandler,
  onCommentEditClickHandler,
  onCommentDeleteClickHandler,
}) => {
  const [areCommentsVisible, setAreCommentsVisible] = useState(false);

  const blogFields = [
    { label: 'Title:', value: blogPost.title, type: 'text' },
    { label: 'Author:', value: blogPost.author, type: 'author' },
    { label: 'Content:', value: blogPost.content, type: 'textarea' },
    { label: 'Excerpt:', value: blogPost.excerpt, type: 'textarea' },
    { label: 'Categories:', value: blogPost.categories, type: 'categories' },
    { label: 'Featured:', value: blogPost.featured, type: 'checkbox' },
    {
      label: 'Show on Blog Page:',
      value: blogPost.showOnBlog,
      type: 'checkbox',
    },
    {
      label: 'Disable comments on Blog Page:',
      value: blogPost.disableCommentsOnBlog,
      type: 'checkbox',
    },
  ];

  const homeBlogPostFields = [
    {
      label: 'Title \n(if different from Title for Blog Page):',
      value: blogPost.homeTitle,
      type: 'text',
    },
    {
      label: 'Excerpt: \n(if different from Excerpt for Blog Page):',
      value: blogPost.homeExcerpt,
      type: 'textarea',
    },
    {
      label: 'Show on Home Page:',
      value: blogPost.showOnHome,
      type: 'checkbox',
    },
  ];

  return (
    <div className='admin-blog-post-card-container'>
      <div className='admin-blog-post-card-top-container'>
        <AdminCardOrderField type='date'>
          {blogPost?.publishedAt}
        </AdminCardOrderField>
        <div className='admin-blog-post-edit-delete-button-container'>
          <ContentChangeButton
            iconType='edit'
            onClickHandler={() => onBlogPostEditClickHandler(blogPost)}
          />
          <ContentChangeButton
            iconType='delete'
            onClickHandler={() => onBlogPostDeleteClickHandler(blogPost)}
          />
        </div>
      </div>

      <div className='admin-blog-post-content-container'>
        <div className='admin-blog-blog-page-container'>
          <h3 className='admin-blog-page-title'>Blog Page</h3>
          <AdminCardImage size='large' img={blogPost.imageUrl} />
          <div className='blog-post-fields-container'>
            {blogFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>

        <div className='admin-blog-home-page-container'>
          <h3 className='admin-blog-page-title'>Home Page</h3>
          <AdminCardImage
            size='large'
            img={blogPost.homeImageUrl}
            noImgMsg={
              '(Upload a photo if different from the photo for Blog Page)'
            }
          />
          <div className='blog-post-fields-container'>
            {homeBlogPostFields.map((field, i) => (
              <AdminCardField key={i} label={field.label} type={field.type}>
                {field.value}
              </AdminCardField>
            ))}
          </div>
        </div>
      </div>

      <div className='admin-blog-comments-toggle-button-container'>
        <ContentChangeButton
          iconType={areCommentsVisible ? 'collapse' : 'expand'}
          size='regular'
          width='variable'
          onClickHandler={() => setAreCommentsVisible((prev) => !prev)}
        >
          {areCommentsVisible ? (
            <span>
              <MdExpandLess className='admin-blog-comments-expand-less-icon' />
              {`Hide Comments`}
            </span>
          ) : (
            <span>
              <MdExpandMore className='admin-blog-comments-expand-more-icon' />
              {`Show Comments`}
            </span>
          )}
        </ContentChangeButton>
      </div>

      <div
        className={`admin-blog-comments-collapse-container ${
          areCommentsVisible ? 'expanded' : 'collapsed'
        }`}
      >
        <div className='admin-blog-comments-container'>
          <div className='admin-blog-title-add-comment-container'>
            <h3 className='admin-blog-comments-title'>Comments</h3>
            <ContentChangeButton
              iconType='add'
              size='regular'
              width='variable'
              onClickHandler={() => onCommentAddClickHandler(blogPost)}
            >
              Add Comment
            </ContentChangeButton>
          </div>

          <div className='admin-blog-comments-list-container'>
            {blogPost.comments && blogPost.comments.length > 0 ? (
              blogPost.comments.map((c, i) => (
                <AdminCommentCard
                  key={i}
                  blogPost={blogPost}
                  comment={c}
                  onEditClickHandler={onCommentEditClickHandler}
                  onDeleteClickHandler={onCommentDeleteClickHandler}
                />
              ))
            ) : (
              <p>No comment yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminBlogPostCard;
